import { GenericError } from '@auth0/auth0-react';
import type { ErrorEvent, EventHint } from '@sentry/react';

// An expired session makes every silent token refresh reject; that is expected, not a bug.
const isExpectedAuthError = (error: unknown): boolean =>
  error instanceof GenericError && error.error === 'login_required';

export const dropExpectedAuthErrors = (event: ErrorEvent, hint: EventHint): ErrorEvent | null => {
  const isUnhandled = event.exception?.values?.some((value) => value.mechanism?.handled === false);
  return isUnhandled === true && isExpectedAuthError(hint.originalException) ? null : event;
};
